<template>
  <div style="display:inline-block">
    <v-btn
      text
      outlined
      @click="payWithRave"
      style="color:lightgray;border:1px solid lightgray"
    >
      Make Payment
    </v-btn>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: 'CheckoutModal',
  created() {
    const script = document.createElement("script");
    script.src = !this.isProduction
      ? "https://ravesandboxapi.flutterwave.com/flwv3-pug/getpaidx/api/flwpbf-inline.js"
      : "https://api.ravepay.co/flwv3-pug/getpaidx/api/flwpbf-inline.js";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  props: {
    isProduction: {
      type: Boolean,
      required: false,
      default: false //set to true if you are going live
    },
    accepted: {
      type: Boolean,
      required: false,
      default: false //set to true if you are going live
    },
    email: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      required: true,
      default: 0
    },
    raveKey: {
      type: String,
      required: true
    },    
    callback: {
      type: Function,
      required: true,
      //default: response => {}
    },
    close: {
      type: Function,
      required: true,
      default: () => {}
    },
    reference: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      default: "ZMW"
    },
    country: {
      type: String,
      default: "ZM"
    },
    form: {
      type: Object,
      default: null
    }
  },
  methods: {
    payWithRave() {
      if (this.accepted == true){
      if (this.form != null){
        if (this.form.validate()){
          window.getpaidSetup({
            customer_email: this.email,
            amount: this.amount,
            txref: this.reference,
            PBFPubKey: this.raveKey,
            onclose: () => this.close(),
            callback: response => this.callback(response),
            currency: this.currency,
            country: this.country,
            custom_title: this.custom_title,
            custom_logo: this.custom_logo,
            payment_method: this.payment_method,
          });
        }
      }else{
        window.getpaidSetup({
          customer_email: this.email,
          amount: this.amount,
          txref: this.reference,
          PBFPubKey: this.raveKey,
          onclose: () => this.close(),
          callback: response => this.callback(response),
          currency: this.currency,
          country: this.country,
          custom_title: this.custom_title,
          custom_logo: this.custom_logo,
          payment_method: this.payment_method,
        });
      }
      }else{
        this.showAlert('Please Accept the Terms of Use!','danger');
      }
    },
    showAlert(text,variant){
      this.components.bootstrap_alert.dismissCountDown = this.components.bootstrap_alert.dismissSecs;
      this.components.bootstrap_alert.variant = variant;
      this.components.bootstrap_alert.alert_text = text;
    },
  },
  computed: {
    ...mapGetters({
      user: "user",
      fullQuote: "fullQuote",
      components: "components"
    })
  }
}
</script>
